import { render } from "./AdminRoles.vue?vue&type=template&id=e890a88a&scoped=true&ts=true"
import script from "./AdminRoles.vue?vue&type=script&lang=ts"
export * from "./AdminRoles.vue?vue&type=script&lang=ts"

import "./AdminRoles.vue?vue&type=style&index=0&id=e890a88a&scoped=true&lang=css"
import "./AdminRoles.vue?vue&type=style&index=1&id=e890a88a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e890a88a"]])

export default __exports__